<!--Dashboard tabs-->
<div class="dashboard-tab">
  <ul class="nav nav-pills" id="pills-tab" role="tablist">
    <li class="nav-item" role="presentation">
      <a class="nav-link" routerLink="../production-overview-admin" routerLinkActive="active">
        Dashboard
      </a>
    </li>
    <li class="nav-item" role="presentation">
      <a class="nav-link" routerLink="../production-overview-admin-table" routerLinkActive="active">
        Report
      </a>
    </li>
  </ul>
</div>

<section>
  <div class="production-overview mt-3" style="background: #fff">
    <div class="dashboard-filter d-flex flex-wrap flex-lg-nowrap gap-2 mb-3" style="white-space: nowrap">
      <!-- Store filter -->
      <div class="filter-wrapper">
        <div class="dropdown stores">
          <div class="report-type" data-bs-toggle="dropdown">
            <small class="filter-text">{{ storeName }}</small>
            <button class="btn text-nowrap" type="button" aria-expanded="false">
              <img src="assets/pos/products/ic_upDown.svg" />
            </button>
          </div>
          <div class="dropdown-menu p-2 mt-1">
            <ul>
              <li (click)="selectAllStores()"><a class="dropdown-item">All stores</a></li>
              <li *ngFor="let str of stores" (click)="setStore(str)">
                <a class="dropdown-item">{{ str.storeName }}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Date range -->
      <div class="filter-wrapper date-range" style="cursor: pointer">
        <div class="dropdown">
          <div class="d-flex ps-0" data-bs-toggle="dropdown" style="width: 18rem">
            <button class="btn text-nowrap" type="button"
              style="border-radius: 8px 0px 0px 8px; border-right: 1px solid #d4d4d4; background: #f5f5f5;">
              <img src="assets/pos/products/ic_leftArrow.svg" />
            </button>
            <input type="text" name="daterangeInput" daterangepicker #dateRange [options]="options"
              (selected)="selectedDate($event, daterange)" style="width: 19rem;height: 100%;" />
            <button class="btn text-nowrap" type="button"
              style="border-radius: 0px 8px 8px 0px; border-left: 1px solid #d4d4d4; background: #f5f5f5;">
              <img src="assets/pos/products/ic_rightArrow.svg" />
            </button>
          </div>
        </div>
      </div>

      <!-- Week color -->
      <div class="filter-wrapper" *ngIf="showWeekColor">
        <div class="dropdown">
          <div class="report-type" data-bs-toggle="dropdown">
            <small class="filter-text">{{ weekColor }}</small>
            <button class="btn text-nowrap" type="button" aria-expanded="false">
              <img src="assets/pos/products/ic_upDown.svg" />
            </button>
          </div>
          <div class="dropdown-menu p-2 mt-1">
            <ul>
              <li (click)="selectAllColors()"><a class="dropdown-item">All Week Colors</a></li>
              <li *ngFor="let wk of weekColorsList" (click)="setWeekColor(wk)">
                <a class="dropdown-item" [style.backgroundColor]="wk.color">{{ wk.displayName }}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="create-btn run-report-btn c-pt" [class.is-loading]="isLoading" (click)="runReport()">
        <span class="run-spinner" *ngIf="isLoading"></span>
        <img *ngIf="!isLoading" src="assets/Pos-Catalog/jam_refresh.svg" class="run-icon" alt="" />
        {{ isLoading ? "Running…" : "Run Report" }}
      </div>
    </div>

    <!-- Empty state -->
    <div class="report-empty-state" *ngIf="!reportHasRun">
      <img src="assets/dashboard/noData.svg" alt="" />
      <h5>Ready when you are</h5>
      <p>Adjust the filters above, then click <strong>Run Report</strong> to generate the admin dashboard.</p>
      <div class="create-btn run-report-btn c-pt" (click)="runReport()">
        <img src="assets/Pos-Catalog/jam_refresh.svg" class="run-icon" alt="" />
        Run Report
      </div>
    </div>

    <div *ngIf="reportHasRun" style="position: relative">
      <!-- Loader -->
      <div class="overlay" *ngIf="isLoading">
        <div class="loader"></div>
      </div>

      <!-- Stats -->
      <div class="stat-text-wrapper" *ngIf="dashboardData?.stat?.length">
        <div class="content" style="background: #e3f5ff">
          <div class="text-content mt-2">
            <small>Total Produced</small>
            <h1 class="mt-2">{{ dashboardData!.stat[0].qty | number }}</h1>
          </div>
          <img src="assets/dashboard/ic_totalEntry.svg" />
        </div>
        <div class="content" style="background: #e3f5ff">
          <div class="text-content mt-2">
            <small>Revenue</small>
            <h1 class="mt-2">{{ dashboardData!.stat[0].price | currency }}</h1>
          </div>
          <img src="assets/dashboard/ic_categories.svg" />
        </div>
        <!-- Total Sold isn't computed by the v3 admin dashboard endpoint yet -->
      </div>

      <div class="no-data-msg text-center py-5" *ngIf="isNoDataFound && !isLoading">
        <img src="assets/dashboard/noData.svg" style="height: 145px" />
        <p style="color: #9e9e9e" class="mt-3">No data found for the selected filters.</p>
      </div>

      <!-- Department chart -->
      <div class="chart-section mt-3" *ngIf="!isDeptData">
        <div class="d-flex justify-content-between mb-2">
          <h6 class="chart-title">Production by Department</h6>
        </div>
        <div class="chart-canvas-wrapper">
          <canvas id="adminDeptV3"></canvas>
        </div>
      </div>

      <!-- Employee chart -->
      <div class="chart-section mt-3" *ngIf="!isEmpData">
        <div class="d-flex justify-content-between mb-2">
          <h6 class="chart-title">Productivity at Employee Level</h6>
        </div>
        <div class="chart-canvas-wrapper">
          <canvas id="adminEmpV3"></canvas>
        </div>
      </div>

      <!-- Brand chart -->
      <div class="chart-section mt-3" *ngIf="!isBrandData">
        <div class="d-flex justify-content-between mb-2">
          <h6 class="chart-title">Productivity at Brand Level</h6>
        </div>
        <div class="chart-canvas-wrapper">
          <canvas id="adminBrandV3"></canvas>
        </div>
      </div>

      <!-- Store doughnut chart -->
      <div class="chart-section mt-3" *ngIf="!isStoreData">
        <div class="d-flex justify-content-between mb-2">
          <h6 class="chart-title">Production at Store Level</h6>
        </div>
        <div class="chart-canvas-wrapper">
          <canvas id="adminStoreV3"></canvas>
        </div>
      </div>
    </div>
  </div>
</section>
